//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { contracFileEditApi, contracFileSaveApi } from '@/api/enterprise';
import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
import { uploader } from '@/utils/uploadCloud';
import file from '@/utils/file';
import { toSrcFn } from '@/utils/format';
import Vue from 'vue';
Vue.use(file);
export default {
  name: 'Record',
  components: {
    ElImageViewer: ElImageViewer
  },
  props: {
    formInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      addRecordShow: false,
      isTitle: '添加跟进记录',
      textarea: '',
      isEdit: null,
      fileName: '',
      iframeIsShow: false,
      percentShow: false,
      avatar: JSON.parse(localStorage.getItem('userInfo')).avatar,
      id: '',
      form: {
        content: '',
        attach_ids: [],
        cid: ''
      },
      rules: {
        content: [{
          required: true,
          message: '请填写记录描述',
          trigger: 'blur'
        }]
      },
      uploadData: {},
      uploadList: [],
      myHeaders: {
        authorization: 'Bearer ' + localStorage.getItem('token')
      },
      successData: {
        type: 'add'
      }
    };
  },
  watch: {
    formInfo: {
      handler: function handler(nVal) {
        if (nVal.type === 'edit') {
          this.form.content = nVal.editData.content;
          this.uploadList = nVal.editData.attachs;
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    focusFn: function focusFn() {
      this.$refs.inoutFocus.focus();
    },
    // 上传文件方法
    uploadServerLog: function uploadServerLog(params) {
      var _this = this;
      this.percentShow = true;
      var file = params.file;
      var options = {
        way: 2,
        relation_type: 'contract',
        relation_id: this.formInfo.type == 'edit' ? this.formInfo.editData.id : 0,
        eid: 0
      };
      uploader(file, 0, 15, options).then(function (res) {
        // 获取上传文件渲染页面
        if (res.name) {
          _this.uploadList.push(res);
          _this.percentShow = false;
        }
      }).catch(function (err) {
        _this.percentShow = false;
      });
    },
    // 删除附件
    deleteTag: function deleteTag(row) {
      this.uploadList = this.uploadList.filter(function (item) {
        return item.id != row.id;
      });
    },
    successChange: function successChange() {
      this.$emit('change', this.successData);
    },
    clientCancel: function clientCancel() {
      this.successData.type = 'edit';
      this.successChange();
    },
    // 判断上传的文件格式文件是否有无图片，无图则为默认
    toSrc: function toSrc(e) {
      return toSrcFn(e);
    },
    // 合同资料
    clientFollowSave: function clientFollowSave() {
      var _this2 = this;
      this.form.attach_ids = [];
      if (!this.form.content) {
        return this.$message.error('记录描述不能为空！');
      }
      if (this.uploadList.length > 0) {
        this.uploadList.map(function (value) {
          _this2.form.attach_ids.push(value.id);
        });
      }
      this.form.cid = this.formInfo.data.cid;
      if (this.formInfo.type == 'add') {
        this.contractFileSave(this.form);
      } else {
        this.contractFileEdit(this.formInfo.editData.id, this.form);
      }
    },
    // 合同资料--添加
    contractFileSave: function contractFileSave(data) {
      var _this3 = this;
      this.loading = true;
      contracFileSaveApi(data).then(function (res) {
        _this3.loading = false;
        _this3.$emit('change', 'add');
        _this3.successData.type = 'add';
        _this3.form.content = '';
        _this3.form.attach_ids = [];
        _this3.uploadList = [];
      }).catch(function (error) {
        _this3.loading = false;
      });
    },
    // 合同资料--修改
    contractFileEdit: function contractFileEdit(id, data) {
      var _this4 = this;
      this.loading = true;
      contracFileEditApi(id, data).then(function (res) {
        _this4.loading = false;
        _this4.clientCancel();
        _this4.form.content = '';
        _this4.form.attach_ids = [];
        _this4.uploadList = [];
      }).catch(function (error) {
        _this4.loading = false;
      });
    }
  }
};